import Vue from 'vue'
import testStoreModule from './store'
import Config from '../../../config'
import axiosIns from './axios'

import EventBus from '@/libs/EventBus'

import helpers from '@/libs/helpers.js'

const storeNameSpace = 'testStore'



function createTestApp(options) {
    const { router, store } = options

    const http = axiosIns({
        BASE_URL: Config.apiUrl,
        store
    })

    return new Vue({
        router,
        store,
        data() {
            return {
                THEME_DEFAULT: 'blank',
                timeCounter: 0,
                startTiming: false, // Cờ đếm thòi gian
                autoSave: null
            }
        },
        async created() {

        },
        methods: {

            convertAudioHtml(html) {

                /*eslint no-constant-condition: ["error", { "checkLoops": false }]*/
                while (true) {

                    const indexFirstAudioTag = html.indexOf('<audio src')

                    if (indexFirstAudioTag == -1) {
                        break;
                    }

                    const indexLastAudioTag = html.substring(indexFirstAudioTag).indexOf('</audio>') + indexFirstAudioTag;

                    const audioHtml = html.substring(indexFirstAudioTag, indexLastAudioTag);

                    let audioSrc = audioHtml.substring(audioHtml.indexOf(`src=`) + 6)
                    audioSrc = audioSrc.substring(0, audioSrc.indexOf('"') - 1);

                    let audioElement = `
                    <div class=\\"audio no-replay\\">
                        <div class=\\"d-flex border card flex-row p-2 shadow mt-2 align-items-center\\">
                            <button>
                                <svg class=\\"play-icon\\" viewBox=\\"0 0 24 24\\" width=\\"24\\" height=\\"24\\" stroke=\\"currentColor\\" stroke-width=\\"2\\" fill=\\"none\\" stroke-linecap=\\"round\\" stroke-linejoin=\\"round\\"><circle cx=\\"12\\" cy=\\"12\\" r=\\"10\\"></circle><polygon points=\\"10 8 16 12 10 16 10 8\\"></polygon></svg>
                                <svg class=\\"pause-icon\\" viewBox=\\"0 0 24 24\\" width=\\"24\\" height=\\"24\\" stroke=\\"currentColor\\" stroke-width=\\"2\\" fill=\\"none\\" stroke-linecap=\\"round\\" stroke-linejoin=\\"round\\"><circle cx=\\"12\\" cy=\\"12\\" r=\\"10\\"></circle><line x1=\\"10\\" y1=\\"15\\" x2=\\"10\\" y2=\\"9\\"></line><line x1=\\"14\\" y1=\\"15\\" x2=\\"14\\" y2=\\"9\\"></line></svg>
                            </button>
                            <div class=\\"ms-2 w-100\\">
                                <div class=\\"d-flex justify-content-between\\">
                                    <p><strong>Bài nghe</strong></p>
                                    <p class=\\"audio-time\\">00:00 / 00:00</p>
                                </div>
                                <p class=\\"alert small text-mute\\">Bạn chỉ được nghe 01 lần, khi đã sẵn sàng bấm play để nghe</p>
                            </div>
                        </div>
                        <audio>
                            <source src=\\"${audioSrc}\\" type=\\"audio/mpeg\\">
                            Your browser does not support the audio element.
                        </audio>
                    </div>`;

                    html = `${html.substring(0, indexFirstAudioTag)}${audioElement.replace(/\n/g, '').replace(/\s\s+/g, '')}${html.substring(indexLastAudioTag + 8, html.length)}`;

                }
                return html;
            },

            getStartWith() {
                return this.$store.getters[`${storeNameSpace}/getStartWith`]
            },

            getTestResult() {
                return new Promise((resolve) => {

                    const testId = this._getHistoryId()

                    http.get(http.ENDPOINT.GET_TEST_RESULT, {
                        params: {
                            test_id: testId
                        }
                    }).then(resp => {
                        resolve(resp.data.data)
                    })

                })
            },

            _autoSave() {
                setTimeout(() => {
                    if (this.startTiming) {
                        this.testSave()
                        this._autoSave()
                    }
                }, 30000)
            },

            qAnswer(questionId, answer) {
                this.$store.commit(`${storeNameSpace}/SET_ANSWER`, {
                    id: questionId,
                    value: answer
                })
            },

            getTimeCouter() {
                return this.timeCounter
            },

            setTimeCountDown() {
                const questionOfPart = this.getQuestionOfPart()

                if (questionOfPart) {
                    if (questionOfPart.time_remaining) {
                        this.timeCounter = questionOfPart.time_remaining
                    } else {
                        this.timeCounter = questionOfPart.time
                    }
                    this.startTiming = true
                }
            },

            countDownTimer() {
                setTimeout(() => {
                    if (this.startTiming) {
                        this.timeCounter -= 1
                        this.$store.commit(`${storeNameSpace}/SET_TIME_REMAINING`, this.timeCounter)

                        // Khi hết thời gian
                        if (this.timeCounter <= 0) {
                            if (this.getQuestionOfPart().part_type == 2) {
                                EventBus.$emit('TIME_UP')
                            } else {
                                this.nextPart()
                            }
                        }
                    }
                    this.countDownTimer()
                }, 1000)
            },

            goToPage(page) {
                if (page) {
                    this.$store.commit(`${storeNameSpace}/SET_PAGE`, page)
                }
                this.$nextTick(() => {
                    setTimeout(() => {
                        window.scrollTo(0, 0);
                    }, 500)
                })
            },

            nextPage() {
                let currentPage = this.getPageCurrent()
                this.goToPage(++currentPage)
            },

            getPageCurrent() {
                return this.$store.state[storeNameSpace].page
            },

            goToPart(part) {
                console.log(part)
                if (part != undefined) {
                    this.$store.commit(`${storeNameSpace}/SET_PART`, part)
                }
            },

            async nextPart() {
                let currentPart = this.getPartCurrent()
                const pageLength = this._getExam().part.length - 1


                await this.testSave(true)

                // chưa đến part cuối
                // save lại bài làm
                // Chuyển qua part tiếp theo
                if (pageLength > currentPart) {
                    this.goToPart(++currentPart)
                    this.setTimeCountDown()
                }

                // đã đến part cuối
                // dừng đếm countdown
                // nộp bài thi
                else {
                    this.testSubmit()
                        .then(() => {


                            if (this.getThemeName() == 'prepare') {
                                this.goToPage(8)
                            } else {
                                this.goToPage(7)
                                this.testNewSession()
                            }
                        })
                    this.startTiming = false
                }

                this.$nextTick(() => {
                    this.$bvModal.hide('confirm-next')
                })
            },

            testSubmit() {
                return new Promise((resolve, reject) => {
                    http.post(http.ENDPOINT.TEST_SUBMIT, {
                        trackid: this._getTracking(),
                        test_data: this._getExam(),
                        update_resutl: false,
                    })
                        .then(res => {
                            if (res.data.code === 1) {
                                return resolve(res.data.message)
                            } else {
                                return reject(res.data.message)
                            }
                        })
                        .catch(error => {
                            return reject(error.message)
                        })
                })
            },


            testSave(overlay = false) {
                return new Promise((resolve, reject) => {


                    if (!this._getHistoryId() || this._getHistoryId() < 0) {
                        return resolve(false)
                    }

                    http.post(http.ENDPOINT.TEST_SAVE, {
                        trackid: this._getTracking(),
                        test_data: this._getExam(),
                        test_id: this._getHistoryId()
                    }, {
                        page_overlay: overlay
                    })
                        .then(res => {
                            if (res.data.code === 1) {
                                return resolve(true)
                            } else {
                                this.$bvToast.toast(res.data.message, {
                                    title: `Có lỗi xảy ra !`,
                                    variant: 'danger',
                                    solid: true
                                })
                                return reject(res.data.msg)
                            }
                        })
                        .catch(error => {
                            this.$bvToast.toast(error.message, {
                                title: `Có lỗi xảy ra !`,
                                variant: 'danger',
                                solid: true
                            })
                            return reject(error.message)
                        })
                })
            },

            getPartCurrent() {
                return this.$store.state[storeNameSpace].part
            },


            // Tiếp tục làm bài thi đang dở
            testContinue(pendingData) {
                if (pendingData) {
                    this._setQuestion(pendingData)
                    this.goToPage(2)
                    this.goToPart(pendingData.partIsUsed)
                }
            },
            testNewSession() {
                // reset ve part 0
                this.goToPart(0)
                const examID = this.$store.getters[`${storeNameSpace}/examID`]
                localStorage.removeItem(`_speakup_exam${examID}`)
            },

            async loadTestInLocal() {
                const questionId = this.$store.state[storeNameSpace].exam.id

                if (questionId) {
                    const testId = localStorage.getItem(`_speakup_exam${questionId}`)

                    if (testId) {
                        this.$store.commit(`${storeNameSpace}/SET_HISTORY_ID`, testId)
                    }
                }
            },



            /**
             * Tìm tracking trong localStorage
             * 
             * @returns {string} trackingID
             */
            _getTracking() {
                let tracking = this.$store.state[storeNameSpace].tracking_id
                if (tracking) {
                    return tracking
                }

                tracking = localStorage.getItem('_speakup_track');
                if (tracking) {
                    this._setTracking(tracking)
                    return tracking
                }
            },

            _setTracking(trackId) {
                this.$store.commit(`${storeNameSpace}/SET_TRACKING_ID`, trackId)
            },

            _setQuestion(examData) {
                this.$store.commit(`${storeNameSpace}/SET_QUESTIONS`, examData)
            },

            _fetchExam() {

                const examId = this.$route.query['exam']
                const examSlug = this.$route.params.examSlug

                const formData = {
                    tracking_id: this._getTracking(),
                }

                if (examId || examSlug) {
                    formData.target = examId ?? examSlug

                    if (examId) {
                        formData.type = 'exam_id'
                    }

                    if (examSlug) {
                        formData.type = 'exam_slug'
                    }
                }

                return new Promise((resolve, reject) => {
                    http.get(http.ENDPOINT.GET_EXAM, {
                        params: formData
                    }).then(resp => {
                        if (resp.data.code == 1) {
                            const examData = resp.data.data
                            this._setQuestion(examData)
                            resolve(examData)
                        }

                        else {
                            this.$store.commit(`${storeNameSpace}/SET_ERROR`, 'INIT_EXAM_ERROR')
                            return reject(false)
                        }
                    })
                        .catch(error => {
                            return reject(error)
                        })
                })
            },

            changeAudioControl() {
                const exam = this._getExam()
                const examAudioConvert = JSON.parse((this.convertAudioHtml(JSON.stringify(exam))))
                this._setQuestion(examAudioConvert)
            },

            _getExamId() {
                return this.$store.state[storeNameSpace].exam.id
            },

            _getExam() {
                return this.$store.state[storeNameSpace].exam
            },

            _getHistoryId() {
                return this.$store.state[storeNameSpace].testHistory.id
            },


            /**
             * 
             * @returns tracking
             */
            async trackingInit() {
                if (!this._getTracking()) {
                    const resp = await http.get(http.ENDPOINT.INIT_TRACKID)
                    if (resp.data.code === 1) {
                        const trackID = resp.data.data
                        this._setTracking(trackID)
                        return trackID
                    }
                    // .then(resp => {

                    // })
                    // .catch(error => {
                    //     return error.message
                    // })
                }
            },

            userInit() {
                const localUserInfo = localStorage.getItem('_speakup_userInfo')
                let userData = {}

                if (localUserInfo) {
                    userData = JSON.parse(localUserInfo || '{}')
                }

                userData.source = document.location.href;
                this.$store.commit(`${storeNameSpace}/SET_CONTACT_INFO`, userData)
            },


            /**
             * Kiem tra bai thi dang làm với mã đề đã config cho trang này
             * 
             */
            checkTestingHistory() {
                return new Promise((resolve, reject) => {
                    if (this._getHistoryId() < 0 || !this._getHistoryId()) {
                        return resolve(false)
                    }

                    http.get(http.ENDPOINT.GET_EXAM_HISTORY, {
                        params: {
                            trackid: this._getTracking(),
                            id: this._getHistoryId(),
                            cid: this.$store.state[storeNameSpace].contactInfo.id
                        }
                    }).then(resp => {
                        if (resp.data.code === 1) {
                            const testData = resp.data.data
                            // Truong hop bai test chua hoan thanh hoac khong co
                            if (testData.status == 0) {
                                return resolve(testData.test_result)
                            }
                            else {
                                return resolve(false)
                            }
                        } else {
                            return resolve(false)
                        }
                    })
                        .catch(error => {
                            return reject('checkExamPending', error)
                        })
                })
            },


            pageSetting() {
                return new Promise((resolve, reject) => {
                    http.get(http.ENDPOINT.SITE_CONFIG)
                        .then(res => {
                            this.$store.commit(`${storeNameSpace}/SET_SETTINGS`, res.data)

                            return resolve(true)
                        })
                        .catch(err => {
                            reject(err)
                        })
                })
            },


            siteSettings() {
                return this.$store.state[storeNameSpace].appSettings
            },

            getThemeName() {
                return this.siteSettings().theme || this.THEME_DEFAULT
            },

            getAppLoading() {
                return this.$store.state[storeNameSpace].loading
            },

            checkLogin() {
                const access_token = helpers.getParameterByName('access_token')
                // Nếu url có kèm theo query refresh_token
                if (access_token) {

                    this.$cookie.set('access_token', access_token)

                    let urlQuery = window.location.search
                    urlQuery = urlQuery.replace('?', '')
                    urlQuery = urlQuery.split('&')
                    for (let index = 0; index < urlQuery.length; index++) {
                        if (urlQuery[index].indexOf('access_token') != -1) {
                            urlQuery.splice(index, 1)
                            break;
                        }
                    }
                    window.history.pushState("", "", `?${urlQuery.join('&')}`);
                }

                this.AuthCheck()
            },

            AuthCheck() {
                const accessToken = this.$cookie.get('access_token')

                if (accessToken) {
                    http.get('/GEauth/userinfo', {
                        headers: {
                            'authorization': 'Bearer ' + accessToken
                        }
                    }).then(res => {
                        if (res.data.code == 1) {
                            this.$cookie.set('ctid', res.data.data.id)
                            this.setContactInfo({
                                id: res.data.data.id,
                                email: res.data.data.email,
                                name: res.data.data.displayName
                            })
                        } else {
                            this.$store.dispatch(`${storeNameSpace}/AuthLogout`)
                        }

                    })
                } else {
                    this.$store.dispatch(`${storeNameSpace}/AuthLogout`)
                }
            },

            userClearInfo() {
                this.$store.dispatch(`${storeNameSpace}/userClearInfo`)
            },

            getExamRule() {
                const exam = this.$store.state[storeNameSpace].exam

                return exam.rules || ''
            },
            getQuestionOfPart(partNumber) {
                if (partNumber) {
                    return this.$store.state[storeNameSpace].exam.part[partNumber]
                }

                return this.$store.state[storeNameSpace].exam.part[this.getPartCurrent()]
            },

            setContactInfo(data) {
                this.$store.commit(`${storeNameSpace}/SET_CONTACT_INFO`, data)
            },

            getContactInfo() {
                return this.$store.getters[`${storeNameSpace}/getContactInfo`]
            },

            pushContact(data) {
                return new Promise((resolve, reject) => {

                    const contact = this.$store.state[storeNameSpace].contactInfo
                    const storeUserInfo = Object.assign(JSON.parse(JSON.stringify(contact)), data)

                    http.post(http.ENDPOINT.PUSH_CONTACT, {
                        trackid: this._getTracking(),
                        data: storeUserInfo
                    })
                        .then(resp => {
                            if (resp.data.code == 1) {
                                const contactId = resp.data.data
                                const userInfo = Object.assign(storeUserInfo, { id: contactId })
                                this.setContactInfo(userInfo)
                                return resolve(userInfo)
                            } else {
                                resolve(false)
                            }
                        })
                        .catch(error => {
                            reject('pushContact', error)
                        })
                })
            },

            pushSurveyForm(data) {
                return new Promise((resolve, reject) => {

                    const contact = this.$store.state[storeNameSpace].contactInfo
                    const storeUserInfo = Object.assign(JSON.parse(JSON.stringify(contact)), data)

                    http.post(http.ENDPOINT.PUSH_SURVEY, {
                        trackid: this._getTracking(),
                        data: storeUserInfo
                    })
                        .then(resp => {
                            if (resp.data.code == 1) {
                                // const contactId = resp.data.data
                                // const userInfo = Object.assign(storeUserInfo, {id: contactId})
                                // this.setContactInfo(userInfo)
                                // return resolve(userInfo)
                                resolve(true)
                            } else {
                                resolve(false)
                            }
                        })
                        .catch(error => {
                            reject('pushSurveyForm', error)
                        })
                })
            },

            createTest() {
                return new Promise((resolve, reject) => {
                    http.post(http.ENDPOINT.TEST_CREATE, {
                        tracking_id: this._getTracking(),
                        exam_id: this._getExamId(),
                    })
                        .then(resp => {
                            if (resp.data.code === 1) {
                                this.$store.commit(`${storeNameSpace}/SET_HISTORY_ID`, resp.data.data)
                                return resolve(resp.data.data)
                            } else {
                                return reject('createTest', false)
                            }
                        })
                        .catch(error => {
                            return reject('createTest', error)
                        })
                })
            },

            pushContactAndCreateTest(data) {
                return new Promise((resolve, reject) => {
                    this.pushContact(data)
                        .then(() => {
                            return this.createTest()
                        })
                        .then(result => {
                            if (result) {

                                this.$analytics.fbq.event('CompleteRegistration', {
                                    value: 20.000,
                                    currency: 'VND',
                                    content_name: 'Signup',
                                    status: 'complete'
                                });

                                // chuyen page tiep theo
                                this.nextPage()

                                return resolve(result)
                            }

                            return reject(false)
                        })
                        .catch(error => {
                            return reject(error)
                        })
                })
            },


            writing(content) {
                this.$store.commit(`${storeNameSpace}/SET_WRITING`, content)
            },
            writingOfPart(part) {
                const contentOfPart = this.getQuestionOfPart(part)
                return contentOfPart.writing || ''
            },

            Start() {
                this.nextPage()
                this.setTimeCountDown()
                if (!this.autoSave)
                    this._autoSave()
            },

            redirect(path = "/") {
                switch (path) {
                    case 'kiem-tra-tu-duy-thuat-toan-th':
                        window.location.assign("https://www.icantech.vn/khoa-hoc/lap-trinh-scratch?utm_campaign=P&utm_source=FA_MKT05_ENG_ICT01_COD_MA081&utm_medium=&utm_content=LDP32_C3_45178_");
                        break;
                    case 'kiem-tra-tu-duy-thuat-toan-thcs':
                        window.location.assign("https://www.icantech.vn/khoa-hoc/lap-trinh-python-code-combat?utm_campaign=P&utm_source=FA_MKT05_ENG_ICT01_COD_MA081&utm_medium=&utm_content=LDP33_C3_45178_");
                        break;
                    case 'kiem-tra-tu-duy-thuat-toan-thpt':
                        window.location.assign("https://www.icantech.vn/khoa-hoc/lap-trinh-python-chuyen-nghiep?utm_campaign=P&utm_source=FA_MKT05_ENG_ICT01_COD_MA081&utm_medium=&utm_content=LDP34_C3_45178_");
                        break;
                    default:
                        window.location.assign("https://www.icantech.vn/khoa-hoc/lap-trinh-scratch?utm_campaign=P&utm_source=FA_MKT05_ENG_ICT01_COD_MA081&utm_medium=&utm_content=LDP32_C3_45178_");
                        break;
                }
            },

            success(path = "/") {
                let str = 'Tham khảo khoá học lập trình Scratch <br/> dành cho học sinh Tiểu học'
                switch (path) {
                    case 'kiem-tra-tu-duy-thuat-toan-th':
                        str = 'Tham khảo khoá học lập trình Scratch <br/> dành cho học sinh Tiểu học'
                        break;
                    case 'kiem-tra-tu-duy-thuat-toan-thcs':
                        str = 'Tham khảo khoá học lập trình Python Code Combat <br/> dành cho học sinh THCS'
                        break;
                    case 'kiem-tra-tu-duy-thuat-toan-thpt':
                        str = 'Tham khảo khoá học lập trình Python chuyên nghiệp <br/> dành cho học sinh THPT'
                        break;
                    default:

                        break;
                }
                return str
            },

            // speaking


            setVideoReplayCount(video_replay) {
                this.$store.commit(`${storeNameSpace}/SET_VIDEO_REPLAY_COUNT`, video_replay)
            },

            speakingVideo(index) {
                this.$store.commit(`${storeNameSpace}/SET_QUESTION_INDEX`, index)
            },

            speakingStep(step) {
                this.$store.commit(`${storeNameSpace}/SET_PART_STEP`, step)
            },

            getStartType() {
                return this.$store.getters[`${storeNameSpace}/getStartType`]
            },

            getError() {
                return this.$store.getters[`${storeNameSpace}/getError`]
            },


            /**
             * Thống kê các câu hỏi đã làm theo từng part
             * Chỉ thống kê với các part câu hỏi dạng bình thường có part_type = 0
             */
            getPartAnalytic() {

                const questionOfPart = this.getQuestionOfPart()

                console.log(questionOfPart)

                if (!questionOfPart) return;
                if (questionOfPart.part_type != 0) return;
                if (questionOfPart.questions.length === 0) return;

                const questions = questionOfPart.questions

                const resultData = {
                    resolve: 0,
                    dontResolve: 0,
                    reReview: 0
                }

                for (let index = 0; index < questions.length; index++) {
                    const question = questions[index];


                    // Dạng bài điền vào chỗ trống
                    // Sẽ có nhiều câu hỏi nhỏ trong 1 câu hỏi
                    // Đếm option_data để biết số lượng câu hỏi cụ thể
                    if (question.content_type == 3) {
                        // số lượng câu hỏi
                        const numberQuestion = question.option_data.length

                        // Số lượng câu hỏi đã trả lời
                        const numberQuestionResolve = question.answers.filter(el => el !== '').length

                        const numberQuestionDontResolve = numberQuestion - numberQuestionResolve

                        resultData.resolve += numberQuestionResolve
                        resultData.dontResolve += numberQuestionDontResolve
                        resultData.reReview += numberQuestionDontResolve
                    }

                    // Dang cau hoi dung sai
                    // Chi co 1 cau hoi
                    if (question.content_type == 1) {

                        // Da trả lời câu hỏi
                        if (question.answers.length !== 0) {
                            resultData.resolve += 1
                        }

                        // chưa trả lời câu hỏi
                        else {
                            resultData.dontResolve += 1
                            resultData.reReview += 1
                        }
                    }

                }

                console.log(resultData)

                return resultData

            },


            setVideoPlayCouter(couter) {
                this.$store.commit(`${storeNameSpace}/SET_VIDEO_REPLAY_COUNT`, couter)
            },
            setQuestionIndex(questionIndex) {
                this.$store.commit(`${storeNameSpace}/SET_QUESTION_INDEX`, questionIndex)
            },
            setPartStep(step) {
                this.$store.commit(`${storeNameSpace}/SET_PART_STEP`, step)
            },
        }
    })
}

export default {
    install: (Vue, options = {}) => {

        const { store, router } = options

        if (store) {
            store.registerModule(storeNameSpace, testStoreModule)
        }


        if (!Vue.prototype.$TestApp) {
            Vue.prototype.$TestApp = {}
        }

        Vue.prototype.$TestApp = createTestApp({ router, store })

        Vue.mixin({

        })
    }
}